module.exports = __webpack_public_path__ + "static/img/4.d0d22bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/4.jpg
// module id = qby9
// module chunks = 16